import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { Faded } from "baby-i-am-faded";
import { default as classNames, default as cs } from "classnames";
import { createContext, forwardRef, useContext, useRef, useState } from "react";
import { useOnClickOutside } from "../utils";
var context = /*#__PURE__*/ createContext({
    isOpen: false,
    setOpen: function() {}
});
export function PopOver(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, items = param.items, button = param.button;
    var ref = useState(false), isOpen = ref[0], setIsOpen = ref[1];
    var panel = useRef();
    useOnClickOutside(panel, function() {
        return setIsOpen(false);
    });
    return /*#__PURE__*/ _jsx(context.Provider, {
        value: {
            isOpen: isOpen,
            setOpen: setIsOpen
        },
        children: /*#__PURE__*/ _jsxs("div", {
            ref: panel,
            className: classNames("relative "),
            children: [
                button,
                /*#__PURE__*/ _jsx(Faded, {
                    duration: 140,
                    children: /*#__PURE__*/ _jsx(Faded, {
                        delay: 50,
                        animationName: "animateOnX",
                        cascade: true,
                        cascadeIncrement: 50,
                        className: cs("absolute p-4 space-y-4 w-max shadow-2xl ring-1", "ring-black ring-opacity-5 overflow-hidden max-w-screen-sm", "flex flex-col mt-3 transform -translate-x-1/2", "left-1/2 bg-white rounded-md dark:bg-gray-700", className, isOpen ? "!block" : "!hidden"),
                        children: items
                    }, isOpen ? "open" : "hidden")
                }, isOpen ? "open" : "hidden")
            ]
        })
    });
}
var Button = /*#__PURE__*/ forwardRef(function Button(param, ref) {
    var children = param.children;
    var _$ref = useContext(context), isOpen = _$ref.isOpen, setOpen = _$ref.setOpen;
    return /*#__PURE__*/ _jsxs("button", {
        ref: ref,
        onClick: function() {
            return setOpen(function(isOpen) {
                return !isOpen;
            });
        },
        className: cs("group rounded-md inline-flex items-center font-medium", "hover:text-opacity-100 focus:outline-none", "focus-visible:ring-2 focus-visible:ring-white", "focus-visible:ring-opacity-75"),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "",
                children: children
            }),
            /*#__PURE__*/ _jsx(ChevronDownIcon, {
                className: classNames("ml-1 pt-1 h-6 w-6 flex-shrink-0 transition ease-in-out", "duration-150 group-hover:text-opacity-80"),
                "aria-hidden": "true"
            })
        ]
    });
});
PopOver.Button = Button;
var Item = /*#__PURE__*/ forwardRef(function Item(_param, ref) {
    var title = _param.title, _description = _param.description, description = _description === void 0 ? "" : _description, _icon = _param.icon, icon = _icon === void 0 ? null : _icon, rest = _object_without_properties(_param, [
        "title",
        "description",
        "icon"
    ]);
    return /*#__PURE__*/ _jsxs("a", _object_spread_props(_object_spread({
        ref: ref,
        className: cs("flex items-center p-2 transition duration-150", "ease-in-out rounded-lg !bg-opacity-60 cursor-pointer", "active:bg-warmGray-200 dark:active:bg-gray-500", "focus:outline-none hover:bg-warmGray-200 dark:hover:bg-gray-500", "focus-visible:ring focus-visible:ring-orange-500", "focus-visible:ring-opacity-50")
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cs("flex items-center justify-center flex-shrink-0", "w-12 h-12"),
                children: icon
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "ml-4",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "font-medium",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm opacity-60",
                        children: description
                    })
                ]
            })
        ]
    }));
});
PopOver.Item = Item;
